/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export const URL = process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://duncanlevings.com";